module.exports = __webpack_public_path__ + "img/baoxiaomi-eye.5d0d1949.png";